/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable prettier/prettier */
import React, { useRef, useState } from 'react';
import { Modal, Button, TextArea, notification } from 'tea-component';
// @ts-ignore
import { useIntl } from 'umi';
import { useRequest, useMemoizedFn, useDebounceFn, useGetState } from 'ahooks';
import TeaConfigProvider from '@/pages/home/components/TeaConfigProvider';
import ImagesUploader from '@/pages/home/components/ImagesUploader';
import { postFeedback } from '@/pages/home/services/home';
import { noop } from '@/pages/home/utils/utils';
import {
  IImagesUploaderInstance,
  IUploadSuccessPayload,
} from '@/pages/home/components/ImagesUploader/types';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './UnloadModal.scss';

export default function UnloadModal(props: any) {
  const { visible, close = noop, showTemplate = true, placeholder ='', describe = '', infoType = 1 } = props;

  const { formatMessage } = useIntl();

  const uploadImageErrorMsg = formatMessage({
    id: 'dbh_feedback_upload_img_error_msg',
    defaultMessage: 'Upload failed, please upload again',
  });

  const { loading, runAsync: postFeedbackRun } = useRequest(postFeedback, {
    manual: true,
  });

  // ImagesUploader组件实例
  const uploaderInstance = useRef<IImagesUploaderInstance>(null);

  const [text, setText] = useState('');
  const [imagesData, setImagesData, getImagesData] = useGetState<IUploadSuccessPayload>({
    success: [],
    error: [],
  });

  // 获取图片存在COS的path列表
  const getImagesPaths = useMemoizedFn(() => {
    const images = imagesData?.success || [];
    return images?.map((image) => image?.path)?.filter((path) => !!path);
  });

  // 提交Feedback
  const submitFeedback = useMemoizedFn(async () => {
    const imagesPaths = getImagesPaths();
    await postFeedbackRun({
      feedback_image: imagesPaths?.join('|'),
      feedback_text: text || '',
      info_type: infoType,
    });
    notification.success({
      unique: true,
      description: formatMessage({
        id: 'dbh_feedback_success_tips',
        defaultMessage: 'Feedback success!',
      }),
      duration: 1000,
    });
    close();
    setText('');
    setImagesData({ success: [], error: [] });
  });

  // 提交Feedback描述，有按钮防抖效果
  const { run: handleSubmit } = useDebounceFn(submitFeedback, {
    wait: 300,
  });

  // 取消
  const handleCancel = useMemoizedFn(async () => {
    close();
    setText('');
    setImagesData({ success: [], error: [] });
    await uploaderInstance?.current?.deleteImgs();
  });

  return (
    <TeaConfigProvider>
      <Modal
        className="unloadModal dbb-feed-modal"
        visible={visible}
        caption={formatMessage({
          id: 'dbh_feedback',
          defaultMessage: 'Feedback',
        })}
        onClose={handleCancel}
      >
        <Modal.Body>
          <div className="unloadModal-title">
            {describe || formatMessage({
              id: 'dbh_feedback_tips',
              defaultMessage:
                'Shower us with praise, or flame us for a bug. We’d love to get your feedback',
            })}
          </div>
          {/* <Button className="unloadModal-title-link" type="link">Use feedback template<SvgIcon type='point-right' className='unloadModal-title-link-icon' /></Button> */}

          {
            showTemplate && <div className='unloadModal-title-link'>
              <a href="https://support.qq.com/product/400291" target="_blank" className='unloadModal-title-link-text'>
                {formatMessage({
                  id: 'dbh_feedback_use_feedback_template',
                  defaultMessage: 'Use feedback template',
                })}<SvgIcon type='point-right' className='unloadModal-title-link-icon' /></a>
            </div>
          }

          <TextArea
            className="unloadModal-input"
            size="full"
            showCount
            maxLength={500}
            value={text}
            onChange={(value) => {
              setText(value);
            }}
            placeholder={placeholder || formatMessage({
              id: 'dbh_feedback_textarea_placeholder',
              defaultMessage: 'Leave your feedback',
            })}
          // onPressEnter={console.log}
          />
          <ImagesUploader
            ref={uploaderInstance}
            // 上传模式为COS时，文件存储路径
            cosPath="/images/feedback"
            // 启用图片压缩时，预计最大接受的图片大小，单位为B，这里配置是6MB，上传的图片超过6MB时 会压缩图片
            maxSize={6 * 1024 * 1024}
            // 是否允许批量上传
            multiple={true}
            // 最多上传图片数量
            max={8}
            // 是否启用上传进度功能
            enabledProgress={true}
            // 是否启用图片压缩功能
            enabledCompress={true}
            // 图片压缩报错提示文案
            compressErrorMsg={uploadImageErrorMsg}
            // 图片上传网络报错提示文案
            networkErrorMsg={uploadImageErrorMsg}
            // 上传成功回调，通过该回调获取 图片数据
            onUploadSuccess={(payload: IUploadSuccessPayload) => {
              setImagesData(payload);
            }}
            className="dbh-f-images-uploader"
            // 删除成功回调
            onDeleteSuccess={(payload: { path: string }) => {
              const { path } = payload || {};
              const imagesData = getImagesData();
              const success = imagesData?.success?.filter((item) => item?.path !== path);
              const error = imagesData?.error?.filter((item) => item?.path !== path);
              const imagesDataTmp = {
                success,
                error,
              };
              setImagesData(imagesDataTmp);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            loading={loading}
            disabled={!text?.trim()?.length}
            onClick={handleSubmit}
          >
            {formatMessage({ id: 'dbh_confirm', defaultMessage: 'Confirm' })}
          </Button>
          <Button type="weak" onClick={handleCancel}>
            {formatMessage({ id: 'dbh_cancel', defaultMessage: 'Cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </TeaConfigProvider>
  );
}
